import styled from 'styled-components'
const SupplierOrderWrapper = styled.div`

  .ant-layout {
    background: ${(props) => props.theme.tokens.surface};
  }

  .ant-layout-sider {
    background: ${(props) => props.theme.tokens.surface};
    margin-right: 10px;
  }

  .ant-layout-content {
    background: ${(props) => props.theme.tokens.surface};
    padding-bottom: 10px;
    text-align: right;
  }

  .btn-center {
    text-align: center
  }

  .text-right {
    text-align: right
  }

  .text-left {
    text-align: left
  }

  .header {
    margin: 5px;
  }

  .link-form {
    color: ${(props) => props.theme.tokens.accent};
    cursor:pointer;
  }

  .image-container {
    display: inline;
    flex-wrap: wrap;
  }

  .image-container > img {
    border: 1px solid ${(props) => props.theme.tokens.border};
    border-radius: 1px;
    padding: 1px;
    margin: 1px;
    width: 30px;
  }

  .detail-container > span {
    color: ${(props) => props.theme.tokens.textPrimary};
  }

  div.ql-toolbar {
    display: none;
  }

  div.ql-editor {
    border-top: 1px solid ${(props) => props.theme.tokens.border};
  }

  .export-pv-btn {
    margin-top: 0;
  }

  .paymentVoucher {
    color: red;
  }

  .filter-toggle {
    margin-top: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  }

  .filter-panel {
    background: ${(props) => props.theme.tokens.surfaceHover};
    border: 1px solid ${(props) => props.theme.tokens.borderSubtle};
    border-radius: 6px;
    padding: 16px;
    margin-top: 16px;
  }

  .filter-panel.filter-panel--hidden {
    display: none;
  }

  .filter-panel .filter-field {
    display: flex;
    flex-direction: column;
    gap: 4px;
    text-align: left;
  }

  .filter-panel .filter-label {
    font-size: 12px;
    color: ${(props) => props.theme.tokens.textSecondary};
    font-weight: 500;
  }

  .filter-actions {
    text-align: left;
    margin-bottom: 12px;
  }

  .supplier-order-mobile-list .ant-list-item {
    padding: 0;
    border: none;
  }

  .supplier-order-mobile-list .supplier-order-card {
    width: 100%;
    border: 1px solid ${(props) => props.theme.tokens.borderSubtle};
    text-align: left;
  }

  .supplier-order-mobile-list .card-row {
    margin-bottom: 6px;
  }

  .supplier-order-mobile-list .card-row:last-child {
    margin-bottom: 0;
  }

  .supplier-order-mobile-list .card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
  }

  .supplier-order-mobile-list .card-header .ref-code {
    flex: 1;
    font-weight: 600;
    font-size: 14px;
  }

  .supplier-order-mobile-list .card-stats {
    display: flex;
    flex-wrap: wrap;
    gap: 4px 16px;
    font-size: 13px;
    padding-top: 6px;
    border-top: 1px dashed ${(props) => props.theme.tokens.borderSubtle};
  }

  .filter-actions .ant-space-item {
    display: flex;
    align-items: center;
  }

  .filter-actions .export-pv-btn {
    margin-top: 0;
  }
`
export default SupplierOrderWrapper